import { MatrixCell } from "./MatrixCell";
import { MatrixRow } from "./MatrixRow";
import { MatrixObject } from "./MatrixObject";

export class ExportCell {
    type: string;
    rowSpan: number;
    colSpan: number;
    width: number;
    value: string;

    constructor(matrixCell: MatrixCell, isExcelImport: boolean) {
        if (isExcelImport) {
            if (matrixCell.isField()) {
                this.type = matrixCell.uniqueId;
                this.value = matrixCell.input.value;
                matrixCell.value = this.value;
            }
        }
        else {
            this.type = matrixCell.type;
            this.rowSpan = matrixCell.rowSpan;
            this.colSpan = matrixCell.colSpan;
            this.width = matrixCell.width;
            if (matrixCell.isField())
                this.value = matrixCell.value;
            else if (matrixCell.isText())
                this.value = matrixCell.input.value;
        }
    }
}

class ExportRow {
    cells: ExportCell[];

    constructor(matrixRow: MatrixRow, isExcelImport: boolean) {
        this.cells = new Array<ExportCell>();
        if (isExcelImport) {
            for (var colIndex = 0; colIndex < matrixRow.cells.length; colIndex++) {
                var cell = matrixRow.cells[colIndex];
                if (cell.isField())
                    this.cells.push(new ExportCell(cell, isExcelImport));
            }
        }
        else {
            for (var colIndex = 0; colIndex < matrixRow.cells.length; colIndex++) {
                var cell = matrixRow.cells[colIndex];
                this.cells.push(new ExportCell(cell, isExcelImport));
            }
        }
    }
}

class Export {
    version: number;
    rows: ExportRow[];
    name: string;
    ereignisBlockId: string;
    tabName: string;
    tabGroup: string;
    multiRow: number;
    guid: string;
    fixedRows: number;
    fixedColumns: number;
    isReadonly: boolean;
    iterationType?: number;
    iterationDateFieldId: number;
    // Guid value used to be sure that even new fields can be used as iteration date.
    iterationDateFieldGuid: string;
    iterationOffset: number;
    iterationEndDateFieldId?: number;
    // Guid value used to be sure that even new fields can be used as iteration date.
    iterationEndDateFieldGuid: string;
    iterationEndDateOffset?: number;
    iterationFirstColumn: number;
    iterationNumberOfColumns: number;
    iterationCount: number;
    intervalType?: number;

    constructor() {
        this.rows = new Array<ExportRow>();
    }
}

export class MatrixExport {
    matrixObject: MatrixObject;
    isExcelImport: boolean;

    constructor(matrixObject: MatrixObject) {
        this.matrixObject = matrixObject;
        this.isExcelImport = matrixObject.useExcelImport;
    }

    getJson(): string {
        var result = new Export();
        for (var rowIndex = 0; rowIndex < this.matrixObject.rows.length; rowIndex++) {
            var row = this.matrixObject.rows[rowIndex];
            result.rows.push(new ExportRow(row, this.isExcelImport));
        }

        result.version = this.matrixObject.version;
        result.name = this.matrixObject.name;
        result.guid = this.matrixObject.guid;
        result.fixedRows = this.matrixObject.fixedRows;
        result.fixedColumns = this.matrixObject.fixedColumns;

        result.tabGroup = this.matrixObject.tabGroup;
        result.tabName = this.matrixObject.tabName;

        result.isReadonly = this.matrixObject.isReadonly;
        if (this.matrixObject.multiRow)
            result.multiRow = this.matrixObject.multiRowValue;
        else
            result.multiRow = 0;

        result.iterationType = this.matrixObject.iterationType;
        result.iterationDateFieldId = this.matrixObject.iterationDateFieldId;
        result.iterationDateFieldGuid = this.matrixObject.iterationDateFieldGuid;
        result.iterationEndDateFieldId = this.matrixObject.iterationEndDateFieldId;
        result.iterationEndDateFieldGuid = this.matrixObject.iterationEndDateFieldGuid;
        result.iterationOffset = this.matrixObject.iterationOffset;
        result.iterationEndDateOffset = this.matrixObject.iterationEndDateOffset;
        result.iterationFirstColumn = this.matrixObject.iterationFirstColumn;
        result.iterationNumberOfColumns = this.matrixObject.iterationNumberOfColumns;
        result.iterationCount = this.matrixObject.iterationCount;
        result.intervalType = this.matrixObject.intervalType;

        return JSON.stringify(result);
    }
}

